module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-BoldItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-BoldItalic-webfont.woff
// module id = 1619
// module chunks = 0